export default __webpack_public_path__ + "static/media/dummygif.38c981f8.gif";